export function getDefaultPostLocationFields() {
  throw new Error('getDefaultPostLocationFields called on the client!');
}

export function getDialogueMessageTimestamps() {
  throw new Error('getDialogueMessageTimestamps called on the client!');
}

export function getPostHTML() {
  throw new Error('getPostHTML called on the client!');
}

export function getDialogueResponseIds() {
  throw new Error('getDialogueResponseIds called on the client!');
}
